<template>
  <section class="section home-news">
    <div class="section-inner">
      <div class="section-header section-header--center">
        <h2 class="section-title">行业资讯</h2>
        <p class="section-subtitle">洞察行业趋势，分享数字化转型实践经验。</p>
      </div>
      <div class="news-list">
        <article
          v-for="item in latestNews"
          :key="item.id"
          class="news-item"
          @click="goDetail(item.id)"
        >
          <div class="news-main">
            <h3 class="news-title">{{ item.title }}</h3>
            <div class="news-meta">
              <span>{{ item.date }}</span>
              <span>· {{ item.author }}</span>
            </div>
            <p class="news-summary">
              {{ item.summary }}
            </p>
          </div>
        </article>
      </div>
      <div class="section-actions">
        <button class="btn-primary" @click="goMore">
          查看更多资讯
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeNews',
  computed: {
    ...mapGetters(['getNewsList']),
    latestNews() {
      return (this.getNewsList || []).slice(0, 3)
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/news/${id}`)
    },
    goMore() {
      this.$router.push('/news')
    }
  }
}
</script>

<style scoped>
.home-news {
  background: #f1f5f9;
}

.section-header--center {
  text-align: center;
}

.section-actions {
  margin-top: 24px;
  text-align: center;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.news-item {
  background: #ffffff;
  border-radius: 14px;
  padding: 16px 18px;
  cursor: pointer;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.08);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.news-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
  background-color: #f8fafc;
}

.news-title {
  font-size: 17px;
  color: #102a43;
  margin-bottom: 4px;
}

.news-meta {
  font-size: 12px;
  color: #9fb3c8;
  margin-bottom: 6px;
}

.news-summary {
  font-size: 14px;
  color: #52606d;
  line-height: 1.7;
}
</style>
